<div class="audio-container">
  @if (hasPromptText) {
    <button type="button" class="audio-generate-btn" (click)="onAudioClick()">Generate Audio</button>
  }
  @if (pollyAudio) {
    <audio class="audio-preview" [attr.src]="pollyAudio" controls controlsList="noplaybackrate nodownload"></audio>
  }
</div>
